import ReactVisibilitySensor from "react-visibility-sensor"
import TabsView from "../../../components/tabs/TabsView/TabsView"
import Footer from "../../../layouts/Footer"
import MainHeader from "../../../layouts/MainHeader"
import stakeholdersPageDataAr from "../../../data/arabic/subpages/stakeholders-page-data-ar"

const StakeholdersPageAr = () => {
  return (
    <main className="page" id="main">
        <div id="stickyViewTwo" className="sticky-view-two type-two">
            <div className="sticky-container">
                <MainHeader
                    title=""
                    image={{
                        src : require(`../../../assets/images/wallpaper/${stakeholdersPageDataAr.header.image.name}`),
                        alt : stakeholdersPageDataAr.header.image.alt,
                    }}
                />
            </div>
            <div className="sticky-container-two" id="mainContent">
                <div className="background-wrapper">
                <div className='wrapper-small'>
                    <h1 className="title-center">{stakeholdersPageDataAr.mainTitle}</h1>
                    <p className="text-paragraph">{stakeholdersPageDataAr.paragraphOne}</p>
                    <ReactVisibilitySensor
                        partialVisibility
                    >
                    {({isVisible} : any) => (
                    <div className="stakeholder-plan">
                        <h3 className={`plan-title ${isVisible ? "visible" : ""}`}>نضع مصالح أصحاب المصلحة في صميم استراتيجيتنا</h3>
                            <img 
                                src={require(`../../../assets/images/plans/${stakeholdersPageDataAr.infoGraphicOne.nameTwo}`)} 
                                alt={stakeholdersPageDataAr.infoGraphicOne.alt}
                                className={`stake-holder-image ${isVisible ? "visible" : ""}`}
                            />
                    </div>
                    )}
                    </ReactVisibilitySensor>
                </div>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <div className="wrapper-larg" style={{ position : "sticky"}}>
                    <TabsView
                        titles={stakeholdersPageDataAr.tabs.headers} 
                        data={stakeholdersPageDataAr.tabs.data} 
                    />
                </div>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <div className="space-50"></div>
                <Footer withBlogs={false} /> 
                </div>
            </div>
        </div>
    </main>
  )    
}
  
export default StakeholdersPageAr